import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { v4 as uuid } from 'uuid';
import { reject } from 'lodash-es';
import { EventManager, Intent } from '../../../library';
export var AlertProvider = function (_EventManager) {
  _inherits(AlertProvider, _EventManager);
  var _super = _createSuper(AlertProvider);
  function AlertProvider() {
    var _this;
    _classCallCheck(this, AlertProvider);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "containers", []);
    return _this;
  }
  _createClass(AlertProvider, [{
    key: "show",
    value: function show(props, id) {
      var verifiedId = !!id ? id : "alert-".concat(uuid());
      this.emit('SHOW', props, verifiedId);
      return verifiedId;
    }
  }, {
    key: "primary",
    value: function primary(props, id) {
      return this.show(_objectSpread(_objectSpread({}, props), {}, {
        intent: Intent.PRIMARY
      }), id);
    }
  }, {
    key: "info",
    value: function info(props, id) {
      return this.show(_objectSpread(_objectSpread({}, props), {}, {
        intent: Intent.INFO
      }), id);
    }
  }, {
    key: "success",
    value: function success(props, id) {
      return this.show(_objectSpread(_objectSpread({}, props), {}, {
        intent: Intent.SUCCESS
      }), id);
    }
  }, {
    key: "warning",
    value: function warning(props, id) {
      return this.show(_objectSpread(_objectSpread({}, props), {}, {
        intent: Intent.WARNING
      }), id);
    }
  }, {
    key: "danger",
    value: function danger(props, id) {
      return this.show(_objectSpread(_objectSpread({}, props), {}, {
        intent: Intent.DANGER
      }), id);
    }
  }, {
    key: "dismiss",
    value: function dismiss(id) {
      this.emit('DISMISS', id);
    }
  }, {
    key: "isActive",
    value: function isActive(id) {
      return this.containers.some(function (_ref) {
        var container = _ref.container;
        return container.isAlertActive(id);
      });
    }
  }, {
    key: "getAlerts",
    value: function getAlerts() {
      this.containers.reduce(function (acc, cur) {
        return [].concat(_toConsumableArray(acc), _toConsumableArray(cur.container.getAlerts()));
      }, []);
    }
  }, {
    key: "clear",
    value: function clear() {
      if (this.containers.length > 0) {
        this.emit('CLEAR');
      }
    }
  }, {
    key: "connect",
    value: function connect(container) {
      this.containers.push({
        id: container.id,
        container: container
      });
      this.start();
    }
  }, {
    key: "disconnect",
    value: function disconnect(container) {
      this.containers = reject(this.containers, ['id', container.id]);
      if (this.containers.length === 0) {
        this.stop();
      }
    }
  }]);
  return AlertProvider;
}(EventManager);